import React from 'react';
import { useSelector } from 'react-redux';

import HeaderColumn from '../header-column/HeaderColumn';
import Icon from '../../../icons/Icon';
import HeaderLabel from '../header-label/HeaderLabel';
import { Skeleton } from '@mui/material';

import scss from './ProjectNameHeader.module.scss';

function ProjectNameHeader({ icon, selector, defaultName, iconProps = {}, isLoading = false }) {
  const projectName = useSelector(selector) || defaultName;

  return (
    <HeaderColumn>
      <div className={scss.wrapper}>
        <Icon icon={icon} disableCommonStyles disableCommonColors className={scss.icon} {...iconProps} />

        <HeaderLabel>
          {isLoading ? <Skeleton variant='text' animation='wave' width={100} height={24} /> : projectName}
        </HeaderLabel>
      </div>
    </HeaderColumn>
  );
}

export default ProjectNameHeader;
